import { Component, ViewChild } from "@angular/core";
import { ViewController, Content, NavController } from "ionic-angular";
import { Store } from "@ngrx/store";

import { AppState } from "../../app/app.reducer";
import { Token, User, Wallet } from "../../app/app.models";
import { UserslistPage } from "../userslist/userslist";
//import { UserprofileeditPage } from '../userprofileedit/userprofileedit';
import { EditUserProfilePage } from "../edit-user-profile/edit-user-profile";

import { WalletService } from "../../services/wallet.service";
import { GeneralPaginService } from "../../services/general.pagin.service";
import { ConfigService } from "../../services/config.service";
import { AppUtilities } from "../../app/app.utilities";
import { AuthService } from "../../services/auth.service";

@Component({
  selector: "page-userprofile",
  templateUrl: "userprofile.html"
})
export class UserprofilePage {
  public tokens$: Token[] = [];
  public user$: User;
  //public userprofileeditPage = UserprofileeditPage;
  public userslistPage = UserslistPage;
  public wallet$: Wallet;
  moreAssets: boolean;
  public refresh;
  @ViewChild(Content)
  content: Content;

  constructor(
    public store: Store<AppState>,
    private generalPaginService: GeneralPaginService,
    private walletService: WalletService,
    private configService: ConfigService,
    public viewCtrl: ViewController,
    private utilities: AppUtilities,
    private authService: AuthService,
    public navCtrl: NavController
  ) {
    this.user$ = this.authService.getUser();
  }

  ionViewDidLoad() {
    console.log("ionViewDidLoad UserprofilePage");
  }

  ionViewWillEnter() {}

  changeMyPhoto() {
    this.navCtrl.push(EditUserProfilePage, {
      user: this.user$,
      nameChange: false
    });
  }

  changeMyName() {
    this.navCtrl.push(EditUserProfilePage, {
      user: this.user$,
      nameChange: true
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/userprofile/userprofile.ts